import { render, staticRenderFns } from "./ubicacionneumaticos.vue?vue&type=template&id=3604a896&scoped=true"
import script from "./ubicacionneumaticos.vue?vue&type=script&lang=js"
export * from "./ubicacionneumaticos.vue?vue&type=script&lang=js"
import style0 from "./ubicacionneumaticos.vue?vue&type=style&index=0&id=3604a896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604a896",
  null
  
)

export default component.exports